import Configuration from '@/agilis/util/Configuration'
import ContextDataTableStore from './ContextDataTableStore'

export default {
  namespaced: true,
  state: {
    selectedContext: {
      baseURL: null,
      applicationId: null,
      workspaceId: null,
      tabId: null,
      trackerStateMachine: null,
      trackerTypeId: null,
      trackerType: null,
      trackerId: null,
      mode: null,
      parentTrackerId: null
    }
  },
  getters: {
    selectedContext (state, getters) {
      return state.selectedContext
    },
    baseURL (state, getters) {
      return state.selectedContext.baseURL
    },
    applicationId (state, getters) {
      return state.selectedContext.applicationId
    },
    application (state, getters, rootState, rootGetters) {
      if (getters.applicationId == null) {
        return null
      }
      const currentApplications = rootGetters['configurationStore/auth/applications']
      return currentApplications[getters.applicationId]
    },
    applicationMaintenance (state, getters, rootState, rootGetters) {
      const app = getters.application

      // Maintenance defined on current app
      let maintenance = app && app.maintenance

      if (!maintenance) {
        // Global maintenance defined on an other app
        const globalMaintenance = rootGetters['configurationStore/maintenance']
        if (globalMaintenance) {
          maintenance = globalMaintenance === true ? {} : globalMaintenance
          maintenance.global = true
        }
      }

      // Verify whiteListed users ...
      const userId = rootGetters['userDataStore/userId']
      const whiteListedUsers = maintenance?.users || []
      const blockUser = whiteListedUsers.indexOf(userId) === -1 // ... user is not whitelisted

      return maintenance ? blockUser && maintenance : false
    },
    applicationName (state, getters) {
      return getters.application != null ? getters.application.name : ''
    },
    workspaceId (state, getters) {
      return state.selectedContext.workspaceId
    },
    tabId (state, getters) {
      return state.selectedContext.tabId
    },
    workspace (state, getters) {
      return Configuration.auth.findWorkspace(
        getters.applicationId,
        getters.workspaceId)
    },
    workspaceName (state, getters) {
      return getters.workspace != null ? getters.workspace.name : ''
    },
    trackerStateMachine (state, getters) {
      return getters.application.stateMachines[getters.trackerType.stateMachine]
    },
    trackerTypes (state, getters) {
      return Configuration.auth.getTrackerTypes(getters.applicationId, getters.workspaceId)
    },
    trackerTypeIds (state, getters) {
      return Object.keys(getters.trackerTypes)
    },
    trackerTypeId (state, getters) {
      return state.selectedContext.trackerTypeId
    },
    trackerType (state, getters) {
      return getters.trackerTypes[state.selectedContext.trackerTypeId]
    },
    trackerId (state, getters) {
      return state.selectedContext.trackerId
    },
    contextMode (state, getters) {
      return state.selectedContext.mode
    },
    parentTrackerId (state, getters) {
      return state.selectedContext.parentTrackerId
    },
    trackerDataTable (state, getters) {
      return Configuration.datatable.getDatatable({
        applicationId: getters.applicationId,
        trackerTypeId: getters.trackerTypeId,
        workspaceId: getters.workspaceId
      })
    },
    trackerDataTableById: (state, getters) => (trackerTypeId) => {
      return Configuration.datatable.getDatatable({
        applicationId: getters.applicationId,
        trackerTypeId: trackerTypeId,
        workspaceId: getters.workspaceId
      })
    },
    trackerDashboard: (state, getters) => {
      const trackerType = getters.trackerType

      const dashboardId = trackerType.dashboardId
      const dashboard = getters.application.dashboard

      return dashboard?.[dashboardId] || null
    }
  },
  mutations: {
    setTrackerId: function (state, trackerId, mode) {
      state.selectedContext = {
        ...state.selectedContext,
        trackerId: trackerId,
        mode: mode
      }
    },
    setSelectedContext: function (state, selectedContext) {
      state.selectedContext = selectedContext
    },
    setBaseURL: function (state, baseURL) {
      state.selectedContext = {
        ...state.selectedContext,
        baseURL
      }
    },
    setSelectedContextDefault: function (state) {
      state.selectedContext = {
        applicationId: null,
        workspaceId: null,
        tabId: null,
        trackerTypeId: null
      }
    }
  },
  modules: {
    dataTable: ContextDataTableStore
  }
}
